module.exports = __webpack_public_path__ + "img/full-brigadeiro-original.b414a3ac.svg";